import React, { FC } from 'react';
import Link from 'next/link';

import type { IMerchant } from 'src/models/IMerchant';
import { Wallet } from 'assets/svg/DetailGoodPage/Wallet';
import { ArrowRoundBack } from 'assets/svg/DetailGoodPage/ArrowRoundBack';

import styles from './styles.module.scss';

interface ProductSeller {
  className?: string;
  merchant?: IMerchant;
}

const ProductSeller: FC<ProductSeller> = ({ className = '', merchant }) => {
  return (
    <div className={`${styles.sellerContainer} ${className}`}>
      {merchant && (
        <div className={styles.sellerInfo}>
          <div className={styles.sellerTitleWrapper}>
            <div className={styles.sellerLabel}>Продавец</div>
            <div className={styles.sellerTitle}>{merchant.legal_name}</div>
          </div>
        </div>
      )}
      <div className={styles.sellerConditions}>
        <div className={styles.sellerConditionsItem}>
          <Wallet />
          <span>Безопасная оплата онлайн</span>
        </div>
        <div className={styles.sellerConditionsItem}>
          <ArrowRoundBack />
          <span>
            Возврат 7 дней, при соблюдении{' '}
            <Link href="/obmen-i-vozvrat" prefetch={false} className={styles.sellerLink}>
              условий
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export { ProductSeller };
